import React, { FC } from "react";
import cn from "classnames";
import { useTranslation } from "react-i18next";
import { Opportunity } from "./types";
import { revolutionizeApproachTrns } from "../trns";
import { useMediaQuery } from "react-responsive";
import { SCREEN_BREAKPOINTS } from "src/constants/screenBreakpoints";

const ICON_SIZE = 80;

interface Props {
  className?: string;
  title: string;
  options: Opportunity[];
}

export const OpportunitiesList: FC<Props> = ({ options, title, className }) => {
  const { t } = useTranslation();

  const isLGScreenBreakpoint = useMediaQuery({
    minWidth: SCREEN_BREAKPOINTS.LG,
  });

  return (
    <div
      className={cn(
        "flex flex-col gap-8 lg:bg-white-purple lg:border rounded-20",
        className
      )}
    >
      <h4 className="text-xl lg:text-2xl text-purple-base text-center font-monument-extended font-medium bg-purple-lighter rounded-20 py-2">
        {t(revolutionizeApproachTrns.subtitle, { name: title })}
      </h4>

      <ul className="flex flex-col gap-3 lg:gap-5 lg:px-10 lg:pb-5">
        {options.map(({ id, title, description, icon }) => (
          <li
            key={id}
            className="flex flex-col gap-5 border lg:border-none rounded-20 p-5 lg:p-0"
          >
            {isLGScreenBreakpoint ? (
              <>
                <img
                  src={icon.url}
                  alt={icon.title}
                  width={ICON_SIZE}
                  height={ICON_SIZE}
                />

                <div className="flex flex-col gap-3">
                  <h5 className="text-2xl text-purple-base font-monument-extended font-medium">
                    {t(title.i18nKey)}
                  </h5>
                  <p className="font-medium font-steppe text-justify">
                    {t(description.i18nKey)}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="flex items-center gap-5">
                  <img
                    src={icon.url}
                    alt={icon.title}
                    width={ICON_SIZE}
                    height={ICON_SIZE}
                  />
                  <h5 className="text-lg text-purple-base font-monument-extended font-medium">
                    {t(title.i18nKey)}
                  </h5>
                </div>

                <p className="font-medium font-steppe">
                  {t(description.i18nKey)}
                </p>
              </>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
